import React, {Component} from 'react';
import styled from 'styled-components';

const CarTypeFieldUl = styled.ul`
    height: 40px;
    line-height: 40px;
    border: 1px #ddd solid;
    line-height: 30px;
    border-radius: 2px;
    font-size: 12px;
    margin: 2px 0px 2px 10px;
    
    li:not(:last-child) {
        border-right: 1px #ddd solid;
    }
    display: inline-block;
    border-right: 0;
    
    white-space: nowrap;
    overflow-y: hidden;
    overflow-x: auto;
    max-width: calc(100% - 16px);
    .fontShadow {
      text-shadow: 0px 0px 0px #333;
    }
    .option__item {
        display: inline-block;
        height: 40px;
        line-height: 40px;
        font-size: 1rem;
        padding-left: 12px;
        padding-right: 12px;
        text-align: center;
        cursor: pointer;
        color: #FFF;
        background-color: #9C0000;
        
        &--inactive {
            /*background-color: #a4a4a4;*/
            color: #000;
            background-color: #FFF;
        }
    }
    
`

class AllCarTypeField extends Component {
    
    render() {
      let options = this.props.options || [];
      if(!options.length) {
        return [];
      }
      return <CarTypeFieldUl>
            <li
              onClick={e => {
                return this.props.onChange({
                  value: true,
                })
              }}
              className={`option__item ${!this.props.value.value ? 'option__item--inactive' : 'fontShadow'}`}
            >
              All
            </li>
          </CarTypeFieldUl>
      
  }

}

export default AllCarTypeField;


// WEBPACK FOOTER //
// ./src/components/car-model-page/AllCarTypeField.js